import { toFeedbackRequest } from '../models/mapper'
import { sendUserFeedbackV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function sendUserFeedback(
  id: number,
  feedback: string,
  isDeclarationDeclined: boolean,
  isPdfIncluded: boolean,
  emails: Array<string>,
  blindCopyEmail: string,
  cancellationReason?: string,
): Promise<void> {
  if (id === null || id === undefined) {
    throw new Error('Transit Operation ID cannot be null or undefined!')
  }
  await sendUserFeedbackV2(
    id,
    toFeedbackRequest(feedback, isDeclarationDeclined, isPdfIncluded, emails, blindCopyEmail, cancellationReason),
  )
}
